import { RestClient } from "clients/rest";

export type B100190ValidRequest = {
  sokoCd: string;
  locationCd: string;
};

//API呼び出し
export const B100190Valid = (props: B100190ValidRequest) => {
  return RestClient.get("b100190/get/valid", {
    params: props,
  });
};

export type B100190FindRequest = {
  headerZoneCd: string;
  headerRetu: string;
  headerRen: string;
};

export type B100190FindResponse = {
  locationCdF: string;
  locationCd: string;
  ren: string;
  dan: string;
  maguti: string;
  nyukolocationKbn: string;
  shukolocationKbn: string;
  version: number;
};

export const B100190Find = (props: B100190FindRequest) => {
  return RestClient.get<B100190FindResponse[]>("b100190/find", {
    params: props,
  });
};

export type B100190CreateRequest = {
  headerZoneCd: string;
  headerRetu: string;
  headerRen: string;
  dan: string;
  maguti: string;
  nyukolocationKbn: string;
  shukolocationKbn: string;
};

// 登録処理
export const B100190Create = (data: B100190CreateRequest) => {
  return RestClient.post("b100190/create", data);
};

export type B100190UpdateRequest = {
  locationCd: string;
  dan: string;
  maguti: string;
  nyukolocationKbn: string;
  shukolocationKbn: string;
  version: number;
};

// 更新処理
export const B100190Update = (data: B100190UpdateRequest) => {
  return RestClient.put("b100190/update", data);
};

export type B100190DeleteRequest = {
  locationCd: string;
};

// 削除処理
export const B100190Delete = (data: B100190DeleteRequest) => {
  return RestClient.delete("b100190/delete", { data: data });
};
